export default __webpack_public_path__ + "static/hero-sortiment-sustenabil-m-71788c0afbbbd5de223f42653d58dce4.jpg";